export const capitalizeFirstLetter = (_string: string): string => {
	return _string.charAt(0).toUpperCase() + _string.slice(1);
};
